import { ref as n, onBeforeUnmount as C, resolveComponent as _, openBlock as b, createBlock as g, createCommentVNode as D } from "vue";
import h from "./design-system.es14.js";
import y from "./design-system.es19.js";
import L from "./design-system.es128.js";
const O = {
  name: "DsConfirmDialogContainer",
  components: { ConfirmDialog: h },
  setup() {
    const o = n(!1), i = n(), r = n(), e = n(), f = n(), t = n(!1), a = n(!1), m = n(), { emitter: c } = y();
    function s(l) {
      o.value = !0, i.value = l.title, r.value = l.message, e.value = l.confirmLabel, f.value = l.cancelLabel, t.value = l.destructive, a.value = l.confirmOnly, m.value = l.size;
    }
    function u() {
      o.value = !1, i.value = void 0, r.value = void 0, e.value = void 0, f.value = void 0, t.value = !1, a.value = !1, m.value = void 0;
    }
    function d() {
      c.emit("confirm"), u();
    }
    function v() {
      c.emit("cancel"), u();
    }
    return c.on("open", s), C(() => {
      c.off("open", s), o.value && c.emit("cancel");
    }), {
      isOpen: o,
      title: i,
      message: r,
      confirmLabel: e,
      cancelLabel: f,
      destructive: t,
      confirmOnly: a,
      size: m,
      handleConfirm: d,
      handleCancel: v
    };
  }
};
function p(o, i, r, e, f, t) {
  const a = _("ConfirmDialog");
  return e.isOpen ? (b(), g(a, {
    key: 0,
    "is-open": "",
    title: e.title,
    message: e.message,
    "confirm-label": e.confirmLabel,
    "cancel-label": e.cancelLabel,
    "confirm-only": e.confirmOnly,
    destructive: e.destructive,
    size: e.size,
    onCancel: e.handleCancel,
    onConfirm: e.handleConfirm
  }, null, 8, ["title", "message", "confirm-label", "cancel-label", "confirm-only", "destructive", "size", "onCancel", "onConfirm"])) : D("", !0);
}
const G = /* @__PURE__ */ L(O, [["render", p]]);
export {
  G as default
};
//# sourceMappingURL=design-system.es15.js.map
